import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { getAllCars } from '../../services/carService';

class Cars extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cars: []
        };

        this._isMounted = false;
    }

    componentDidMount = async () => {
        this._isMounted = true;
        if (this._isMounted) {
            const { data: cars } = await getAllCars();
            console.log(cars);
            this.setState({ cars });
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    render() {
        return (
            <div>
                <h1 className="text-center text-3xl font-medium nav-font mt-3">Online cars</h1>
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-0 lg:mt-4 p-4 lg:p-0">
                    {this.state.cars ? this.state.cars.map((car) =>
                        <Link key={car._id} className="w-full border rounded-xl p-2" to={`/car/${car._id}`}>
                            <img className="w-full h-auto rounded-md" src={car.imgURL} alt="" />
                            <h2 className="font-thin text-xl text-center">{car.name}</h2>
                            <p className="font-semibold text-sm text-center">Duration: {car.duration / 60} min</p>
                        </Link>
                    ) :
                        <div className="flex flex-col border items-center animate-pulse w-72 h-auto bg-gray-50 rounded-xl p-2" >
                            <div className="w-full h-72 rounded-md bg-gray-300" alt="" />
                            <p className="w-24 h-3 mt-3 bg-gray-300 rounded" />
                            <p className="w-8 h-2 mt-2 bg-gray-300 rounded" />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Cars;